export default __webpack_public_path__ + "media/images/valid-icon-blue-df2ae0bf.svg";